/*
* FullScreenButton.js
* Created on 2-12-2019
* @author Swen Meeuwes for &ranj
*/

import BrowserDetect from '../../../../lib/html5-software-library/src/ranj/util/BrowserDetect';
import screenfull from 'screenfull';

export default class FullScreenButton {
    initialize() {
        this._dom = document.getElementById("fullScreenButton");
        this._dom.addEventListener("click", this._handleClick.bind(this));
        this._dom.addEventListener("mouseenter", this._handleMouseEnter.bind(this));

        this._dom.style.display = "block";

        if (BrowserDetect.isIphone()) {
            this._dom.style.display = "none";
        }
    }

    _handleClick(evt) {
        this._toggle();
    }

    _handleMouseEnter(evt) {
        this._dom.classList.remove("pulse");
    }

    _toggle() {
        if (screenfull.isEnabled) {
            screenfull.toggle();
        }
    }
}